// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Product_style_wrapper__LOSlx"};